import { render, staticRenderFns } from "./PrescriptionCard.vue?vue&type=template&id=48e819e0&scoped=true"
import script from "./PrescriptionCard.vue?vue&type=script&lang=js"
export * from "./PrescriptionCard.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionCard.vue?vue&type=style&index=0&id=48e819e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e819e0",
  null
  
)

export default component.exports